var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Treeselect,_vm._b({attrs:{"normalizer":_setup.normalizer,"options":_setup.options,"disable-fuzzy-matching":"","value":_setup.patchedValue},on:{"input":_setup.onInput}},'treeselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }